import http from "../http-common";
import authHeader from "./auth-header";

class PresupuestosDataService {
  getAll() {
    return http.get("/api/presupuestos/todos", { headers: authHeader() });
  }

  filter(term, page, size, sortName, sortOrder) {
    return http.get("/api/presupuestos/filtra", {
      headers: authHeader(),
      params: {term: term, page: page, size: size, sortName: sortName, sortOrder: sortOrder}
    });
  }

  getAllPaginated(page, size, sortName, sortOrder) {
    return http.get("/api/presupuestos/todos", {
      headers: authHeader(),
      params: {page: page, size: size, sortName: sortName, sortOrder: sortOrder}
    });
  }

  getPresupuesto(idPresupuesto) {
    return http.get("/api/presupuestos/" + idPresupuesto, {
      headers: authHeader()
    });
  }

  createPresupuesto(entity) {
    return http.post("/api/presupuestos", entity, { headers: authHeader() });
  }

  updatePresupuesto(entity) {
    return http.put("/api/presupuestos", entity, { headers: authHeader() });
  }

  aceptarParcial(idPresupuesto, idsLineasAceptadas, lastModifiedOn) {
    return http.post(
      `/api/presupuestos/${idPresupuesto}/aceptar-parcial`,
      { id: idPresupuesto, idsLineasAceptadas, lastModifiedOn },
      { headers: authHeader() }
    );
  }

  updatePresupuestoTemporal(entity) {
    return http.put("/api/presupuestos/temporales", entity, {
      headers: authHeader()
    });
  }

  deletePresupuesto(entity) {
    return http.delete("/api/presupuestos", {
      headers: authHeader(),
      data: entity
    });
  }

  getUltimos(numeroRegistros) {
    return http.get("/api/presupuestos/ultimos/" + numeroRegistros, {
      headers: authHeader()
    });
  }

  duplicarPresupuesto(id) {
    return http.post(`/api/presupuestos/${id}/duplicar`, null, {
      headers: authHeader()
    });
  }

  getPresupuestosConfirmadosOrEntregados() {
    return http.get("/api/presupuestos/confirmados-o-entregados", {
      headers: authHeader()
    });
  }

  //By Asunto
  filterByAsunto(idAsunto, term, page, size, sortName, sortOrder) {
    return http.get("/api/presupuestos/filtrabyAsunto", {
      headers: authHeader(),
      params: {idAsunto: idAsunto, term: term, page: page, size: size, sortName: sortName, sortOrder: sortOrder}
    });
  }

  getAllPaginatedByAsunto(idAsunto, page, size, sortName, sortOrder) {
    return http.get("/api/presupuestos/filtrabyAsunto", {
      headers: authHeader(),
      params: {idAsunto, term: "", page, size, sortName, sortOrder}
    });
  }

  getAceptadosPorProveedor({term = ""} = {}) {
    return http.get("/api/presupuestos/aceptados-por-proveedor", {
      headers: authHeader(),
      params: {term}
    });
  }

  toggleExclusionLinea(lineaId, excluido, lastModifiedOn) {
    return http.put(
      `/api/presupuestos/lineas/${lineaId}/exclusion`,
      { excluido, lastModifiedOn },
      { headers: authHeader() }
    );
  }
  
  toggleExclusionMasiva(lineas, excluido) {
    return http.put(
        "/api/presupuestos/lineas/exclusion-masiva",
        {excluido, lineas},
        {headers: authHeader()}
    );
  }

  generatePedidosProveedor(payload) {
    return http.post("/api/presupuestos/generar-pedidos", payload, {
      headers: authHeader()
    });
  }

  validarCambioTipo(idPresupuesto, codigoTipo) {
    return http.get(`/api/presupuestos/${idPresupuesto}/validar-cambio-tipo`, {
      headers: authHeader(),
      params: {codigoTipo: codigoTipo}
    });
  }

  //PDF
  getPresupuestoPdf = (id, language = "es") =>
    http.get(`/api/presupuestos/${id}/pdf`, {
      headers: authHeader(),
      params: { language },
      responseType: "blob"
    });

  getPresupuestoSinTotalPdf = (id, language = "es") =>
    http.get(`/api/presupuestos/${id}/pdf-sin-total`, {
      headers: authHeader(),
      params: { language },
      responseType: "blob"
    });

  getFacturaProformaPdf = (id, language = "es") =>
    http.get(`/api/presupuestos/${id}/factura-proforma`, {
      headers: authHeader(),
      params: {language},
      responseType: "blob"
    });

  getConfirmacionPedidoPdf = (id, language = "es") =>
    http.get(`/api/presupuestos/${id}/confirmacion-pedido`, {
      headers: authHeader(),
      params: {language},
      responseType: "blob"
    });
}

export default new PresupuestosDataService();
